import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthStore } from '../state/auth.store';
const REFRESH_PATH = '/hub/auth/refresh';

// Recuperación de contraseña: son flujos pre-login del backoffice y NO tienen
// tienda asociada. El IAM decide el template del mail por la presencia de
// X-Store-Id (con store => template de e-commerce, sin store => template HUB),
// así que mandarlo — aunque venga de un estado residual en storage — hace que
// el operador reciba el mail equivocado.
const STORELESS_AUTH_PATHS = ['/hub/auth/reset-password', '/hub/auth/confirm-password'];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authStore = inject(AuthStore);
  const state = authStore.state();

  const isLogin = req.url.includes('/hub/auth/login');
  const isRegister = req.url.includes('/hub/auth/register');
  const isRefresh = req.url.includes(REFRESH_PATH);
  const isStorelessAuth = STORELESS_AUTH_PATHS.some((path) => req.url.includes(path));

  let headers = req.headers;

  // Inyecta Authorization en todas las requests excepto login (que usa credentials anónimas)
  if (!isLogin && state.accessToken) {
    headers = headers.set('Authorization', `Bearer ${state.accessToken}`);
  }

  // Siempre que tengamos contexto de store/tenant, lo mandamos (también en login).
  if (!isStorelessAuth && state.storeId !== null && state.storeId !== undefined) {
    headers = headers.set('X-Store-Id', state.storeId ?? '');
  }

  if (!isStorelessAuth && state.tenantId !== null && state.tenantId !== undefined) {
    headers = headers.set('X-Tenant-Id', state.tenantId ?? '');
  }

  if (state.user?.id) {
    headers = headers.set('X-User-Id', state.user.id);
  }

  if (state.user?.email) {
    headers = headers.set('X-User-Email', state.user.email);
  }

  const isLogout = req.url.includes('/hub/auth/logout');
  const withCredentials = isLogin || isRefresh || isLogout;

  return next(req.clone({ headers, withCredentials }));
};
